import ForgotPassword from '../components/ForgotPassword'
import { forgotPasswordServiceConfig } from './shared/config'

import injectWidget from './shared/injectWidget'

const ForgotPasswordWidget = injectWidget({
  widget: ForgotPassword,
  serviceConfig: forgotPasswordServiceConfig,
})

export default ForgotPasswordWidget
